import { render, staticRenderFns } from "./kv-typography.vue?vue&type=template&id=5aeda253"
import script from "./kv-typography.vue?vue&type=script&lang=js"
export * from "./kv-typography.vue?vue&type=script&lang=js"
import style0 from "./kv-typography.vue?vue&type=style&index=0&id=5aeda253&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports